import { render } from "./Registro.vue?vue&type=template&id=8aa4f0f0&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"

import "./Registro.vue?vue&type=style&index=0&id=8aa4f0f0&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa4f0f0"]])

export default __exports__